"use client";

// Le compte à rebours d'une promotion sur l'achat à vie d'une formation.
//
// Il ne rend rien tant que la première mesure n'est pas faite : l'heure du
// serveur et celle du navigateur diffèrent toujours un peu, et afficher une
// durée calculée au rendu serveur puis corrigée au montage ferait sauter le
// chiffre sous les yeux du visiteur.
//
// Il s'éteint tout seul à l'échéance, et prévient son parent : la remise
// n'est plus appliquée au paiement, l'affichage ne doit pas la promettre.

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

function remainingParts(endsAt) {
    const left = new Date(endsAt).getTime() - Date.now();
    if (!Number.isFinite(left) || left <= 0) return null;

    const seconds = Math.floor(left / 1000);
    return {
        days: Math.floor(seconds / 86400),
        hours: Math.floor((seconds % 86400) / 3600),
        minutes: Math.floor((seconds % 3600) / 60),
        seconds: seconds % 60,
    };
}

export default function PromoCountdown({ endsAt, onExpire, icon = false }) {
    const t = useTranslations();
    const [parts, setParts] = useState(null);

    useEffect(() => {
        const tick = () => {
            const next = remainingParts(endsAt);
            setParts(next);
            if (!next && onExpire) onExpire();
        };
        tick();
        // Une seconde : le dernier jour, c'est elle qui fait l'urgence. Le
        // reste du temps l'affichage ne change qu'à la minute, mais l'écart
        // de coût est nul face au rendu d'une fiche.
        const timer = setInterval(tick, 1000);
        return () => clearInterval(timer);
    }, [endsAt, onExpire]);

    if (!parts) return null;

    // Deux unités suffisent : « 4 j 23 h » se lit d'un coup d'œil, là où
    // « 4 j 23 h 54 min » se déchiffre. Les secondes n'apparaissent que dans
    // la dernière heure, quand elles font vraiment l'urgence.
    //
    // Espaces INSÉCABLES entre le nombre et son unité : sur la carte d'une
    // fiche, « 7 j 06 h » se coupait après le 7 et la ligne passait à deux.
    const pad = (value) => String(value).padStart(2, "0");
    const value =
        parts.days > 0
            ? `${parts.days}\u00a0j ${pad(parts.hours)}\u00a0h`
            : parts.hours > 0
              ? `${parts.hours}\u00a0h ${pad(parts.minutes)}\u00a0min`
              : `${parts.minutes}\u00a0min ${pad(parts.seconds)}\u00a0s`;

    return (
        <span className="inline-flex items-center gap-1 whitespace-nowrap">
            {icon && <SolarIcon name="alarm-linear" className="text-sm" />}
            {t("course_access_promo_left", { value })}
        </span>
    );
}
